import { render, staticRenderFns } from "./shippingAddress.vue?vue&type=template&id=b479ca3e"
import script from "./shippingAddress.vue?vue&type=script&lang=js"
export * from "./shippingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports